import React from 'react';
import { Header } from './Header';

const index = () => {
  return (
    <>
      <Header />
    </>
  );
};

export default index;
